// Mixin for pages that want to show recurring payments in the sidebar
// Requires: Services mixin (for _getRecurringPayments), registerSidebar injection

export default {
	inject: ['registerSidebar'],

	data() {
		return {
			recurringPayments: [],
			selectedRecurringPaymentId: null
		}
	},

	methods: {
		fetchAndRegisterRecurringPayments() {
			this._getBankingInfo(() => {
				this._getRecurringPayments((res) => {
					this.recurringPayments = res.payments || [];
					this.registerRecurringPaymentsSidebar();
				});
			});
		},

		registerRecurringPaymentsSidebar() {
			if (!this.registerSidebar) return;

			const items = this.recurringPayments.map(rp => {
				const account = this.bankInfo?.accounts?.find(a => a.id === rp.bankAccountId);
				const accountLabel = account ? `${account.bankDisplayName} · ${account.displayName}` : null;
				return {
					id: rp.merchantName,
					title: rp.merchant ? rp.merchant.name : rp.merchantName,
					subtitle: accountLabel || null,
					meta: `£${Math.abs(rp.lastAmount).toFixed(2)}`,
				meta2: `Day ${rp.avgPaymentDay}`,
					statusChip: rp.increasing
						? { label: 'increasing', color: 'red', icon: 'mdi-arrow-up', variant: 'tonal' }
						: rp.changing
							? { label: 'decreasing', color: 'green', icon: 'mdi-arrow-down', variant: 'tonal' }
							: { label: 'stable', color: 'green', icon: 'mdi-check', variant: 'outlined' }
				};
			});

			this.registerSidebar({
				config: {
					actionButton: null,
					pageItemsTitle: 'Recurring Payments',
					pageItems: items,
					currentPageItemId: this.selectedRecurringPaymentId
				},
				data: this,
				handlers: {
					onActionClick: () => {},
					onPageItemClick: (id) => { this.filterByRecurringPayment(id); },
					onPageItemDelete: () => {},
					onPageItemRename: () => {},
					onOpenSettings: () => { this.showSettings = true; }
				}
			});
		},

		filterByRecurringPayment(merchantName) {
			this.selectedRecurringPaymentId = merchantName;
			this.searchQuery = merchantName;
			this.registerRecurringPaymentsSidebar();
		},

		clearRecurringPaymentFilter() {
			this.selectedRecurringPaymentId = null;
			this.registerRecurringPaymentsSidebar();
		}
	}
}
